
class TokenService {
  getLocalAccessToken() {
    if (typeof window !== "undefined" && window.localStorage.getItem("user") !== 'undefined') {
      const user = JSON.parse(window.localStorage.getItem("user"))
      return user?.token;
    }
  }
  updateLocalAccessToken(token) {
    let user = JSON.parse(localStorage.getItem("user"));
    user.token = token;
    localStorage.setItem("user", JSON.stringify(user));
  }
  getUser() {
    return (
      typeof window !== "undefined" && JSON.parse(localStorage.getItem("user"))
    );
  }
  setUser(user) {
    localStorage.setItem("user", JSON.stringify(user));
  }
  setProfile(user) {
    localStorage.setItem("profile", JSON.stringify(user));
  }
  returnAvatar() {
    const profile = JSON.parse(localStorage.getItem("profile"));
    return profile?.avatar
  }
  removeUser() {
    localStorage.removeItem("profile");
    localStorage.removeItem("goftinoProfile");
    localStorage.removeItem("goftinoUserId");
    localStorage.removeItem("goftino_5DZIKP");
    localStorage.removeItem("goftino_unread_5DZIKP");
    localStorage.removeItem("goftino");
    localStorage.removeItem("user");
    localStorage.removeItem("token");
  }
}
export default new TokenService();
